module.exports = __webpack_public_path__ + "static/media/donation.ad08eb88.png";